import React from "react";
import { IconButton } from "@design-system/button"
import { CloseIcon } from "@design-system/icons"

import {
  createStyles,
  forwardRef,
} from "@design-system/core"
import { CloseButtonProps } from "./types";

const styles = createStyles((theme) => ({
  root: {
    position: "absolute",
    right: theme.spaces.spacing8,
    top: theme.spaces.spacing8,
  }
}))

export const CloseButton = forwardRef<CloseButtonProps, "div">(
  (props, ref) => {
    const { children, style, ...rest } = props

    return (
      <IconButton
        ref={ref}
        type="button"
        aria-label="Close"
        icon={<CloseIcon />}
        style={[styles.root, style]}
        {...rest}
      />      
    )
  }
)
